import { CommonModule } from "@angular/common";
import { Component, inject, OnInit } from "@angular/core";

import { DeviceManagementTableComponent } from "@bitwarden/angular/auth/device-management/device-management-table.component";
import { JslibModule } from "@bitwarden/angular/jslib.module";
import { I18nService } from "@bitwarden/common/platform/abstractions/i18n.service";
import {
  BadgeModule,
  ButtonModule,
  IconModule,
  LinkModule,
  TableModule,
} from "@bitwarden/components";
import { I18nPipe } from "@bitwarden/ui-common";

// FIXME(https://bitwarden.atlassian.net/browse/CL-764): Migrate to OnPush
// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: "app-web-device-management-table",
  templateUrl: "./web-device-management-table.component.html",
  host: {
    class: "bv-security-devices-table-host",
  },
  imports: [
    BadgeModule,
    ButtonModule,
    CommonModule,
    IconModule,
    I18nPipe,
    JslibModule,
    LinkModule,
    TableModule,
  ],
})
export class WebDeviceManagementTableComponent
  extends DeviceManagementTableComponent
  implements OnInit
{
  private readonly webI18nService = inject(I18nService);

  override ngOnInit(): void {
    super.ngOnInit();

    const deviceColumn = { ...this.columnConfig[0], title: this.webI18nService.t("devices") };
    const statusColumn = this.columnConfig[1];
    const firstLoginColumn = this.columnConfig[2];

    this.columnConfig = [deviceColumn, firstLoginColumn, statusColumn];
  }
}
